
import React from 'react';
import { SimulationConfig } from '@/types';
import { SmartInput } from './SmartInput';
import { Toggle } from './Toggle';

interface AudioVolumeSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const AudioVolumeSection: React.FC<AudioVolumeSectionProps> = ({ config, setConfig }) => {
  return (
    <div className="flex flex-col gap-6">
        <SmartInput 
          label="Master Volume" 
          settingKey="masterVolume"
          min={0} 
          max={2} 
          step={0.01} 
          value={config.masterVolume ?? 1.0} 
          onChange={v => setConfig(p => ({ ...p, masterVolume: v }))} 
          darkMode={config.darkMode} 
          fullWidth
        />
        
        <div className="grid grid-cols-2 gap-4">
          <SmartInput 
            label="Melody" 
            settingKey="melodyVolume"
            min={0} 
            max={1} 
            step={0.01} 
            value={config.melodyVolume ?? 1.0} 
            onChange={v => setConfig(p => ({ ...p, melodyVolume: v }))} 
            darkMode={config.darkMode} 
          />
          
          <SmartInput 
            label="SFX" 
            settingKey="fxVolume"
            min={0} 
            max={1} 
            step={0.01} 
            value={config.fxVolume ?? 0.8} 
            onChange={v => setConfig(p => ({ ...p, fxVolume: v }))} 
            darkMode={config.darkMode} 
          />
        </div>

        <div className="h-px bg-zinc-500/10 my-2" />

        <div className={`flex items-center justify-between p-4 rounded-2xl transition-all ${config.darkMode ? 'bg-cyan-500/5 border-cyan-500/10' : 'bg-cyan-50/30 border-cyan-500/10 shadow-sm'}`}>
          <div className="flex flex-col">
            <span className="text-[10px] font-black uppercase tracking-widest leading-none">Rhythmic: MIDI Sync Bouncing</span>
            <span className="text-[8px] font-bold opacity-40 uppercase tracking-tight mt-1">Forces ball to hit at exact MIDI event timing</span>
          </div>
          <Toggle 
            active={config.rhythmicDeterministicBounce} 
            onClick={() => setConfig(p => ({ ...p, rhythmicDeterministicBounce: !p.rhythmicDeterministicBounce }))} 
          />
        </div>
    </div>
  );
};
